export default __webpack_public_path__ + "static/media/icon_Metis.fc9ab63a.svg";